module.exports = __webpack_public_path__ + "img/logo-white.a03152e2.png";